import styled from 'styled-components'

export const SupportContainer = styled.div`
  width: 100%;
  color: #c00000;
  margin-bottom: 10px;
  font-size: 15px;
`

export const SupportTitle = styled.div`
  text-align: center;
`

export const SupportLink = styled.span`
  display: flex;
  justify-content: center;
  align-items: center;
`

export const SupportText = styled.span`
  margin: 10px;
  cursor: pointer;
  text-decoration: underline;
`

export const SupportIcon = styled.img`
  height: 20px;
  width: 20px;
  cursor: pointer;
`
